import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function TargetIcon({
  className,
  color = "currentColor",
  size,
}: IconProps): ReactElement {
  return (
    <SvgIcon size={size} className={className} viewBox="0 0 24 24">
      <g clipPath="url(#clip0_target)">
        <path
          d="M12 12L21 3"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3638 5.63624C16.7947 4.06881 14.7016 3.13655 12.4869 3.01859C10.2721 2.90064 8.09192 3.60531 6.36517 4.9972C4.63841 6.3891 3.48695 8.37002 3.13203 10.5593C2.77711 12.7486 3.24377 14.9919 4.44234 16.858C5.64092 18.7242 7.48685 20.0815 9.62543 20.6693C11.764 21.2571 14.0444 21.0338 16.0284 20.0424C18.0123 19.051 19.5599 17.3614 20.3738 15.2982C21.1877 13.2351 21.2104 10.9439 20.4376 8.86499"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1819 8.81817C14.4729 8.10932 13.5475 7.65754 12.5525 7.53451C11.5575 7.41148 10.5499 7.62424 9.68956 8.13905C8.82925 8.65386 8.1655 9.44122 7.80362 10.3762C7.44173 11.3112 7.40245 12.3403 7.692 13.3001C7.98154 14.26 8.58334 15.0956 9.40189 15.6745C10.2204 16.2534 11.2089 16.5424 12.2104 16.4956C13.2118 16.4488 14.169 16.0689 14.93 15.4161C15.691 14.7634 16.2122 13.8752 16.4109 12.8925"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_target">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
